import styled from 'styled-components'

import { applyIPadOnlyStyle } from 'helpers/css'

export const CtaSection = styled.div`
    width: 75%;
    ${({ applyMarginTop }) => `margin-top:${applyMarginTop ? 3 : 0}vh`};
    ${applyIPadOnlyStyle('width: 100%', {
        min: 0,
        max: 1370,
        orientation: 'both',
    })}
`

export const CtaBtns = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 100%;
`

export const BtnWithSubText = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 10px;
`

export const SubText = styled.p`
    font-weight: 400;
    font-size: 12px;
    margin: 12px 0 0 0;
    text-align: center;
    ${applyIPadOnlyStyle('display: none', {
        min: 0,
        max: 1370,
        orientation: 'both',
    })}
`
